module.exports = __webpack_public_path__ + "img/pagi.6e73aceb.png";